import { useSeo } from '@/hooks/useSeo';
import { useJsonLd } from '@/hooks/useJsonLd';

export default function SeoManager() {
  useSeo();
  useJsonLd();
  return null;
}